export const CREATE_PROMO_CODE_REQUEST = 'CREATE_PROMO_CODE_REQUEST';
export const CREATE_PROMO_CODE_SUCCESS = 'CREATE_PROMO_CODE_SUCCESS';
export const CREATE_PROMO_CODE_FAILURE = 'CREATE_PROMO_CODE_FAILURE';

export const VALIDATE_PROMO_CODE_REQUEST = 'VALIDATE_PROMO_CODE_REQUEST';
export const VALIDATE_PROMO_CODE_SUCCESS = 'VALIDATE_PROMO_CODE_SUCCESS';
export const VALIDATE_PROMO_CODE_FAILURE = 'VALIDATE_PROMO_CODE_FAILURE';

export const APPLY_PROMO_CODE_REQUEST = 'APPLY_PROMO_CODE_REQUEST';
export const APPLY_PROMO_CODE_SUCCESS = 'APPLY_PROMO_CODE_SUCCESS';
export const APPLY_PROMO_CODE_FAILURE = 'APPLY_PROMO_CODE_FAILURE';

export const GET_PROMO_CODES_REQUEST = 'GET_PROMO_CODES_REQUEST';
export const GET_PROMO_CODES_SUCCESS = 'GET_PROMO_CODES_SUCCESS';
export const GET_PROMO_CODES_FAILURE = 'GET_PROMO_CODES_FAILURE';

export const DELETE_PROMO_CODE_REQUEST = 'DELETE_PROMO_CODE_REQUEST';
export const DELETE_PROMO_CODE_SUCCESS = 'DELETE_PROMO_CODE_SUCCESS';
export const DELETE_PROMO_CODE_FAILURE = 'DELETE_PROMO_CODE_FAILURE';